import './ModalReopenSubsxcribe.scss';

import { Cancel } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { UnpyEvent } from 'domain/event/UnpyEvent';
import { UnpyEventView } from 'domain/event/UnpyEventView';
import { formatDate } from 'helper/date.helper';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { EventReopenSubscribeForm } from 'primary/events/forms/EventReopenSubscribeForm';
import React, { FC } from 'react';

import { useTranslate } from '../../hooks/useTranslate';

interface ModalReopenSubscribeProps {
  event: UnpyEvent | UnpyEventView;
  handleClose: () => void;
  onSubmitted: (event: UnpyEvent | UnpyEventView) => void;
}

export const ModalReopenSubscribe: FC<ModalReopenSubscribeProps> = ({
  handleClose,
  event,
  onSubmitted,
}) => {
  const t = useTranslate();
  return (
    <Box className={'modalReopenSubscribe'}>
      <div className={'modalReopenSubscribe__container'}>
        <div className={'modalReopenSubscribe__container-header'}>
          <div className={'-headerRow'}>
            <h2>{t('event.modalReopenSubscribe.title', { eventName: event.name })}</h2>
            <IconButton onClick={handleClose} className={'-closeBtn'}>
              <Cancel />
            </IconButton>
          </div>
          <div className={'-headerRow -center'}>
            <KeyValue
              alignStart
              accent
              keyValue={t('event.form.labels.endSubscribeDate')}
              value={formatDate(event.endSubscribeDate, 'readable(with hour)')}
            />
            <KeyValue
              accent
              alignStart
              keyValue={t('event.form.labels.startDateTime')}
              value={formatDate(event.startDateTime, 'readable(with hour)')}
            />
          </div>
        </div>
        <div className={'modalReopenSubscribe__container-content'}>
          <EventReopenSubscribeForm
            event={event}
            onSubmitted={(event) => {
              onSubmitted(event);
              handleClose();
            }}
            closeModal={handleClose}
          />
        </div>
      </div>
    </Box>
  );
};
